import { render, staticRenderFns } from "./CalendarCustomHeader.vue?vue&type=template&id=a06ca22e&"
import script from "./CalendarCustomHeader.vue?vue&type=script&lang=js&"
export * from "./CalendarCustomHeader.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCustomHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports